import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import './AmexGDAEditorialCard.scss';

const AmexGDAEditorialCard = (
  {
    blogData, isDesktop, position, blogLen, Analytics,
  }
) => {
  const {
    title, id, imageLink, author, link, cityName,
  } = { ...blogData };

  const onClickTagging = (restaurantName) => {
    const extraParams = {
      action_name: 'Editorial - Click',
      item_name: restaurantName,
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParams);
  };

  const sanitizedTitle = sanitizeString(title);

  const renderCardContentFn = () => {
    let renderCardContent = '';
    const cardContent = (
      <div
        className={cx('GDA__EditorialCard--wrapper', {
          paddingcard: position < blogLen - 1,
        })}
      >
        <div
          className="GDA__EditorialCard--image"
          style={{
            backgroundImage: `url(${imageLink})`,
          }}
        />
        {cityName && (<h3 className="GDA__EditorialCard--cityname">{cityName}</h3>)}
        <p
          className="GDA__EditorialCard--blogtitle"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedTitle,
          }}
        />
        <p className="GDA__EditorialCard--author">
          {author}
        </p>
      </div>
    );

    if (link) {
      const opts = {};
      if (isDesktop) {
        opts.tabIndex = -1;
      }
      renderCardContent = (
        <Link
          target="_blank"
          href={link}
          rel="noopener noreferrer"
          onContextMenu={() => onClickTagging(title)}
          onClick={() => onClickTagging(title)}
          key={id}
          {...opts}
        >
          {cardContent}
        </Link>
      );
    } else {
      renderCardContent = cardContent;
    }
    return (
      renderCardContent
    );
  };

  if (isDesktop) {
    return (
      <div className="GDA__EditorialCard">
        {renderCardContentFn()}
      </div>
    );
  }
  return (
    <li className="GDA__EditorialCard mobile-card">
      {renderCardContentFn()}
    </li>
  );
};

AmexGDAEditorialCard.defaultProps = {
  blogData: {},
  isDesktop: false,
  showMoreClicked: false,
  position: 0,
  blogLen: 0,
};

AmexGDAEditorialCard.propTypes = {
  blogData: PropTypes.shape({
    id: PropTypes.number,
    imageLink: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
    cityName: PropTypes.string,
    link: PropTypes.string,
  }),
  isDesktop: PropTypes.bool,
  showMoreClicked: PropTypes.bool,
  position: PropTypes.number,
  blogLen: PropTypes.number,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexGDAEditorialCard;
